import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/fragment/AppSidebar';
import { AppBar } from '@/components/fragment/AppBar';
import { useAppSelector } from '@/store/hooks';
import { selectAppBarVisible } from '@/store/dashboard';

interface SidebarLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export function SidebarLayout({ children }: SidebarLayoutProps) {
  const appBarVisible = useAppSelector(selectAppBarVisible);

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className='min-w-0'>
        {appBarVisible && <AppBar />}
        <main className='flex flex-1 flex-col overflow-hidden'>{children}</main>
      </SidebarInset>
    </SidebarProvider>
  );
}
